export const DEFAULT_COOKIE_SETTINGS = {
  path: '/',
  maxAge: 60 * 60 * 24 * 3,
}

export const GMP_LOCALE_COOKIE_NAME = 'i18n-locale'
export const PRIMER_CHECKOUT_TOGGLE_COOKIE_NAME = 'primer_checkout'
